import React, { FC } from 'react'

import Box from '@mui/material/Box'

interface IProps {
    children?: React.ReactNode
    dir?: string
    index: number
    value: number
}

const TabPanel: FC<IProps> = ({ children, value, index, ...rest }) => (
    <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...rest}>
        {value === index && <Box>{children}</Box>}
    </div>
)

export default TabPanel
